import { FaGithubSquare } from 'react-icons/fa';
import { BsLinkedin } from 'react-icons/bs';
import { SiLeetcode } from "react-icons/si";
import { SiGeeksforgeeks } from "react-icons/si";

const data = [
    { id: 1, link: "https://github.com/Akb98443", icon: <FaGithubSquare />, tooltip : "My Github Profile"},
    { id: 2, link: "https://www.linkedin.com/in/akb98443/", icon: <BsLinkedin />,tooltip : "My Linkedin Profile" },
    {id : 3, link: "https://leetcode.com/u/jems1123/" ,icon : <SiLeetcode/>,tooltip : "My Leetcode Profile" },
    {id : 4, link: "https://www.geeksforgeeks.org/user/avanish6745/" ,icon : <SiGeeksforgeeks />,tooltip : "My GFG Profile" }


]

export default data;